import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref, watch } from "vue";

import { useStore } from "@/stores";
import { ReportResult } from "@/app-data/report/entities/reportEntity";
import Ipc from "@/views/components/IpcTag.vue";
import { API_BIS_CATEGORY_TREE, API_BIS_REPORT_STAT } from "@/configs/Apis";
import { isEmptyOrWhiteSpace } from "@/utils/Common";
import DuduAjax from "@/utils/DuduAjax";


export default /*#__PURE__*/_defineComponent({
  __name: 'ReportFilter',
  props: {
  reportDefine: { type: Object, required: true },
  reportData: { type: Object, required: true },
  dataByFilter: { type: Boolean, required: true },
},
  emits: ["reFilter"],
  setup(__props, { emit }) {

const props = __props;





const store = useStore();

const reportFilters = ref<Array<any>>([]);

const IGNORE_MAX_LIMIT: Array<string> = ["applicantProvince"];
const MAX_LIMIT = 20;

const years = ref<Array<string>>([]);
const months = ref<Array<string>>([]);

const activeFilters = ref<Array<string>>([]);

const defaultStartYear = 1980;
const defaultEndYear: number = new Date().getFullYear();
const defaultStartMonth = 1;
const defaultEndMonth: number = new Date().getMonth() + 1;

const categoryTreeData = ref<Array<any>>([]);
const categoryTreeDataLoaded = ref(false);

const categoryTreeRefs: { [name: string]: any } = {};

const setCategoryTreeRef = (name: string, el: any) => {
  categoryTreeRefs[name] = el;
};

const getProjectId = () => (store.state as any).project.info.id;

onMounted(() => {
  const cyear = new Date().getFullYear();
  for (let y = 1980; y <= cyear; y++) {
    years.value.push(y + "");
  }

  for (let m = 1; m <= 12; m++) {
    if (m < 10) {
      months.value.push("0" + m);
    } else {
      months.value.push(m + "");
    }
  }
});

watch(
  () => props.reportData,
  () => {
    if (props.dataByFilter) {
      return;
    }

    reportFilters.value = [];
    activeFilters.value = [];
    categoryTreeData.value = [];
    categoryTreeDataLoaded.value = false;

    const reportData = props.reportData as ReportResult;
    if (!reportData.dataValues || reportData.dataValues.length === 0 || reportData.rowCount === 0) {
      return;
    }

    const rowDimValues: Array<Array<any>> = [];
    for (let k = 0; k < reportData.rowCount; k++) {
      for (let i = 0; i < reportData.rowDimNodes[k].length; i++) {
        if (!reportData.rowDimNodes[k][i]) {
          continue;
        }
        if (!reportData.rowDimNodes[k][i].total) {
          if (!rowDimValues[i]) {
            rowDimValues[i] = [];
          }
          if (rowDimValues[i].indexOf(reportData.rowDimNodes[k][i].value) < 0) {
            rowDimValues[i].push(reportData.rowDimNodes[k][i].value);
          }
        }
      }
    }

    const reportDefine = props.reportDefine as any;
    for (let i = 0; i < reportDefine.rowDims.length; i++) {
      const dim = reportDefine.rowDims[i];
      initFilterByDim(dim, rowDimValues[i] || [], "row");
    }

    if (reportDefine.colDims) {
      const colDimValues: Array<Array<any>> = [];
      for (let k = 0; k < reportDefine.colDims.length; k++) {
        colDimValues[k] = [];
        for (let i = 0; i < reportData.colDimNodes.length; i++) {
          if (!reportData.colDimNodes[i][k]) {
            continue;
          }
          if (!reportData.colDimNodes[i][k].total) {
            if (colDimValues[k].indexOf(reportData.colDimNodes[i][k].value) < 0) {
              colDimValues[k].push(reportData.colDimNodes[i][k].value);
            }
          }
        }
      }
      for (let i = 0; i < reportDefine.colDims.length; i++) {
        const dim = reportDefine.colDims[i];
        initFilterByDim(dim, colDimValues[i] || [], "col");
      }
    }
  }
);

const initFilterByDim = async (dim: any, dimValues: Array<any>, dimType: string) => {
  if (dim.dateUnit) {
    const filter: any = {
      dimType,
      dim,
    };
    if (dim.dateUnit === "YEAR") {
      filter.type = "year";
      filter.startYear = defaultStartYear;
      filter.endYear = defaultEndYear;

      if (dimValues && dimValues.length > 0) {
        filter.startYear = Math.min(...dimValues);
        filter.endYear = Math.max(...dimValues);
      }

      reportFilters.value.push(filter);
      activeFilters.value.push(filter.dim.name + "_" + filter.type);
    } else if (dim.dateUnit === "MONTH") {
      const reportDefine = props.reportDefine as any;
      for (let i = 0; i < reportDefine.rowDims.length; i++) {
        if (
          reportDefine.rowDims[i].name === dim.name &&
          reportDefine.rowDims[i].dateUnit &&
          reportDefine.rowDims[i].dateUnit === "YEAR"
        ) {
          return;
        }
      }

      if (reportDefine.colDims) {
        for (let i = 0; i < reportDefine.colDims.length; i++) {
          if (
            reportDefine.colDims[i].name === dim.name &&
            reportDefine.colDims[i].dateUnit &&
            reportDefine.colDims[i].dateUnit === "YEAR"
          ) {
            return;
          }
        }
      }

      filter.type = "month";
      filter.startYear = defaultStartYear;
      filter.startMonth = defaultStartMonth;
      filter.endYear = defaultEndYear;
      filter.endMonth = defaultEndMonth;

      if (dimValues && dimValues.length > 0) {
        dimValues.sort();
        const startYM = dimValues[0].split("-");
        filter.startYear = startYM[0];
        filter.startMonth = startYM[1];

        const endYM = dimValues[dimValues.length - 1].split("-");
        filter.endYear = endYM[0];
        filter.endMonth = endYM[1];
      }

      reportFilters.value.push(filter);
      activeFilters.value.push(filter.dim.name + "_" + filter.type);
    }

    return;
  }

  if (dim.name.indexOf("category") === 0) {
    loadCategoryTree(dim, dimValues, dimType);
    return;
  }

  const reportDefine = props.reportDefine as any;
  const rdim: any = {
    name: dim.name,
    label: dim.label,
    limit: 10,
  };
  if (dim.table) {
    rdim.table = dim.table;
  }
  if (dim.currentId) {
    rdim.currentId = dim.currentId;
  }
  if (dim.self) {
    rdim.self = dim.self;
  }
  const definition = {
    rowDims: [rdim],
    colDims: [],
    measures: reportDefine.measures,
    showNoDataDims: true,
    condition: reportDefine.condition,
  };

  const datas: any = await DuduAjax.post<ReportResult>(
    { url: API_BIS_REPORT_STAT, path: { projectId: getProjectId(), UC: 1 } },
    definition
  ).catch(() => "");
  if (!datas) {
    return;
  }
  const filter = initFilterByDimAndData(dim, datas, dimValues, dimType);
  reportFilters.value.push(filter);
  activeFilters.value.push(filter.dim.name + "_" + filter.type);
};

const initFilterByDimAndData = (dim: any, datas: ReportResult, dimValues: Array<any>, dimType: string) => {
  const filter: any = {
    dimType,
    dim,
  };

  if (dim.name === "patentType") {
    filter.type = "enum";
    filter.selectedDims = [];
    filter.allDims = [];
    filter.selectedDims = dimValues || [];

    for (let j = 0; j < datas.rowCount; j++) {
      let counts = [0];
      if (datas.dataValues[datas.rowColIndexes[j][0]]) {
        counts = datas.dataValues[datas.rowColIndexes[j][0]];
      }

      filter.allDims.push({
        title: datas.rowDimNodes[j][0].label,
        value: datas.rowDimNodes[j][0].value,
        count: counts.join("),("),
      });
    }
  } else {
    filter.type = "text";
    filter.selectedDims = [];
    filter.allDims = [];
    filter.minLimit = 1;
    if (IGNORE_MAX_LIMIT.indexOf(dim.name) < 0) {
      // filter.maxLimit = MAX_LIMIT;
    } else {
      filter.maxLimit = 100;
    }
    filter.loadedAll = false;
    filter.offset = 0;
    filter.dimValues = dimValues;
    filter.selectedDims = dimValues || [];

    for (let j = 0; j < datas.rowCount; j++) {
      let counts = [0];
      if (datas.dataValues[datas.rowColIndexes[j][0]]) {
        counts = datas.dataValues[datas.rowColIndexes[j][0]];
      }

      filter.allDims.push({
        title: datas.rowDimNodes[j][0].label,
        value: datas.rowDimNodes[j][0].value,
        count: counts.join("),("),
      });
    }
  }

  if (dim.limit && filter.allDims.length < dim.limit) {
    filter.loadedAll = true;
  }

  return filter;
};

const loadCategoryTree = async (dim: any, dimValues: Array<any>, dimType: string) => {
  if (categoryTreeDataLoaded.value) {
    initCategoryDimFilter(dim, dimValues, dimType);
    return;
  }

  const data: any = await DuduAjax.get<Array<any>>(
    { url: API_BIS_CATEGORY_TREE, path: { projectId: getProjectId() } },
    {},
    false
  ).catch(() => "");
  const treeData: Array<any> = [];
  const map = new Map<string, any>();
  if (data && data.length) {
    data.forEach((item: any) => {
      if (item.treeLevel === 0) {
        return;
      }

      let treeItem;
      if (map.has(item.id)) {
        treeItem = map.get(item.id);
        if (isEmptyOrWhiteSpace(treeItem.title)) {
          Object.assign(treeItem, item);
        }
      } else {
        treeItem = { name: item.name, id: item.id, parentId: item.parentId || 0, count: item.count || 0 };
        map.set(item.id, treeItem);
      }

      if (item.treeLevel === 1) {
        treeData.push(treeItem);
      } else {
        const pId = item.parentId;
        if (map.has(pId)) {
          const pItem = map.get(pId);
          if (!Object.prototype.hasOwnProperty.call(pItem, "children")) {
            pItem.children = [];
          }
          pItem.children.push(treeItem);
        } else {
          map.set(pId, { children: [treeItem] });
        }
      }
    });
  }
  categoryTreeData.value = treeData;
  categoryTreeDataLoaded.value = true;

  initCategoryDimFilter(dim, dimValues, dimType);
};

const initCategoryDimFilter = (dim: any, dimValues: Array<any>, dimType: string) => {
  const filter: any = {
    dimType,
    dim,
    type: "category",
    selectedDims: dimValues || [],
    allDims: [],
  };

  for (let j = 0; j < categoryTreeData.value.length; j++) {
    if (dim.name === "category" + categoryTreeData.value[j].id) {
      filter.allDims = categoryTreeData.value[j].children;
      break;
    }
  }

  reportFilters.value.push(filter);
  activeFilters.value.push(filter.dim.name + "_" + filter.type);
};

const loadMoreDim = async (filter: any) => {
  if (filter.loadedAll) {
    return;
  }

  filter.offset += 10;
  const dim = filter.dim;
  const rdim: any = {
    name: dim.name,
    label: dim.label,
    limit: 10,
    offset: filter.offset,
  };
  if (dim.table) {
    rdim.table = dim.table;
  }
  if (dim.currentId) {
    rdim.currentId = dim.currentId;
  }
  if (dim.self) {
    rdim.self = dim.self;
  }
  const definition = {
    rowDims: [rdim],
    colDims: [],
    measures: (props.reportDefine as any).measures,
    showNoDataDims: true,
    condition: (props.reportDefine as any).condition,
  };

  const datas: any = await DuduAjax.post<ReportResult>(
    { url: API_BIS_REPORT_STAT, path: { projectId: getProjectId(), UC: 1 } },
    definition
  ).catch(() => "");
  if (!datas) {
    return;
  }
  if (datas.rowCount === 0) {
    filter.loadedAll = true;
    return;
  }
  for (let j = 0; j < datas.rowCount; j++) {
    let counts = [0];
    if (datas.dataValues[datas.rowColIndexes[j][0]]) {
      counts = datas.dataValues[datas.rowColIndexes[j][0]];
    }

    filter.allDims.push({
      title: datas.rowDimNodes[j][0].label,
      value: datas.rowDimNodes[j][0].value,
      count: counts.join("),("),
    });
  }

  if (datas.rowCount < 10) {
    filter.loadedAll = true;
  }
};

const reFilter = async () => {
  const reportDefine = props.reportDefine as any;
  const definition: any = {
    rowDims: [],
    colDims: [],
    measures: [],
    showNoDataDims: reportDefine.showNoDataDims,
  };

  if (reportDefine.queryBean) {
    definition.queryBean = reportDefine.queryBean;
  }

  const valueRanges: any = {};
  for (let i = 0; i < reportFilters.value.length; i++) {
    const filter: any = reportFilters.value[i];
    if (filter.type === "year" && filter.startYear && filter.endYear) {
      valueRanges[filter.dimType + "_" + filter.dim.name + "__y"] = [filter.startYear, filter.endYear];
    } else if (filter.type === "month" && filter.startYear && filter.endYear && filter.startMonth && filter.endMonth) {
      valueRanges[filter.dimType + "_" + filter.dim.name + "__m"] = [
        filter.startYear + "-" + filter.startMonth,
        filter.endYear + "-" + filter.endMonth,
      ];
    } else if (filter.type === "enum" && filter.selectedDims && filter.selectedDims.length > 0) {
      valueRanges[filter.dimType + "_" + filter.dim.name] = [filter.selectedDims.join(",")];
    } else if (filter.type === "category") {
      const tree = categoryTreeRefs[filter.dim.name];
      const selectedIds = tree ? tree.getCheckedKeys() : [];
      if (selectedIds.length === 0) {
        selectedIds.push(-1);
      }
      valueRanges[filter.dimType + "_" + filter.dim.name] = [selectedIds.join(",")];
    } else if (filter.type === "text" && filter.selectedDims && filter.selectedDims.length > 0) {
      valueRanges[filter.dimType + "_" + filter.dim.name] = [filter.selectedDims.join(",")];
    }
  }

  for (let i = 0; i < reportDefine.rowDims.length; i++) {
    const dim: any = JSON.parse(JSON.stringify(reportDefine.rowDims[i]));
    dim.limit = 0;

    let dimName = dim.name;
    if (dim.dateUnit) {
      if (dim.dateUnit === "YEAR") {
        dimName += "__y";
      } else if (dim.dateUnit === "MONTH") {
        dimName += "__m";
      }
    } else if (dim.name.indexOf("category") === 0) {
      dim.self = true;
    }
    if (valueRanges["row_" + dimName]) {
      dim.valueRange = valueRanges["row_" + dimName];
    }

    definition.rowDims.push(dim);
  }

  if (reportDefine.colDims) {
    for (let i = 0; i < reportDefine.colDims.length; i++) {
      const dim: any = JSON.parse(JSON.stringify(reportDefine.colDims[i]));
      dim.limit = 0;

      let dimName = dim.name;
      if (dim.dateUnit) {
        if (dim.dateUnit === "YEAR") {
          dimName += "__y";
        } else if (dim.dateUnit === "MONTH") {
          dimName += "__m";
        }
      } else if (dim.name.indexOf("category") === 0) {
        dim.self = true;
      }
      if (valueRanges["col_" + dimName]) {
        dim.valueRange = valueRanges["col_" + dimName];
      }

      definition.colDims.push(dim);
    }
  }

  for (let i = 0; i < reportDefine.measures.length; i++) {
    const measure: any = JSON.parse(JSON.stringify(reportDefine.measures[i]));
    definition.measures.push(measure);
  }

  if (!reportDefine.condition) {
    definition.condition = {};
  } else {
    definition.condition = JSON.parse(JSON.stringify(reportDefine.condition));
  }

  if (!definition.condition.items) {
    definition.condition.items = [];
  }

  const datas: any = await DuduAjax.post<ReportResult>(
    { url: API_BIS_REPORT_STAT, path: { projectId: getProjectId(), UC: 1 } },
    definition
  ).catch(() => "");
  if (datas) {
    emit("reFilter", datas);
  }
};

return { __sfc: true,props, emit, store, reportFilters, IGNORE_MAX_LIMIT, MAX_LIMIT, years, months, activeFilters, defaultStartYear, defaultEndYear, defaultStartMonth, defaultEndMonth, categoryTreeData, categoryTreeDataLoaded, categoryTreeRefs, setCategoryTreeRef, getProjectId, initFilterByDim, initFilterByDimAndData, loadCategoryTree, initCategoryDimFilter, loadMoreDim, reFilter, Ipc }
}

})